module.exports = __webpack_public_path__ + "8be3f1f67bc7cbfd624aa1a0ed86cc93.MP3";